export const i18n = {
  defaultLocale: 'en',
  locales: ['en']
} as const;

export type Locale = (typeof i18n)['locales'][number];

export function flattenMessages(nestedMessages: Record<string, any>, prefix = ''): Record<string, string> {
  return Object.keys(nestedMessages).reduce((messages: Record<string, any>, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
}
